<template>
  <main role="main">

    <section class="jumbotron">
      <div class="container" style="width: 90%; margin: 0 auto;">
        <div class="rich_media_content " id="js_content" style="visibility: visible;">

          <p style="text-align: left;"><br></p>
          <p style="white-space: normal;"><span style="font-size: 20px;color: rgb(255, 104, 39);"></span></p>
          <section style="padding-top: 1px;padding-bottom: 1px;white-space: normal;font-size: 14px;">
            <h2
                style="margin-top: 5px;margin-bottom: 5px;padding-right: 10px;padding-left: 10px;font-weight: bold;border-left: 5px solid rgb(176, 125, 62);line-height: 32px;color: rgb(176, 125, 62);border-top-color: rgb(176, 125, 62);border-bottom-color: rgb(176, 125, 62);border-right-color: rgb(176, 125, 62);">
              <p style="border-color: rgb(176, 125, 62);"><span style="font-size: 18px;">公众号：Auto office</span></p></h2>
          </section>
          <p></p>
          <p style="white-space: normal;"><span style="font-size: 15px;letter-spacing: 1px;">鹰迅课堂项目由<b><font color="#FFC000">吉林省 “互联网＋”
            金奖</font></b>，挑战杯特等奖、国家级铜奖项目主持人、<b><font color="#0077F6">中科软科技股份有限公司Java全栈开发工程师吴灿锦</font></b>可以提供一对一的Java开发学习指导。</span><br>
          </p>
          <p style="white-space: normal;"><span style="font-size: 15px;letter-spacing: 1px;">
            本项目主持人吴灿锦可以提供一对一的Java开发学习指导，从企业需求视觉出发，
            带您像鹰一样迅速掌握SpringBoot、SpringCouldAlibaba全家桶、Redis、RabbitMQ、ElasticSearch、xxl-job、Sentinel、Seata、Vue等技术栈，迅速成为一名高级Java开发工程师。<br></span>
          </p>
          <p style="white-space: normal;">
            <span style="font-size: 15px;letter-spacing: 1px;">
            吴灿锦的毕业设计—《基于SpringCloud Alibaba微服务在线教育系统的设计与实现》也曾获得吉林财经大学优秀毕业设计，也可辅导毕业设计系统的开发。
            <br></span>
          </p>
          <p style="white-space: normal;"><span style="font-size: 16px;letter-spacing: 1px;"><font
              color="#C00000"><b>商务合作微信号：yxclass001</b></font></span>
          </p>
          <p style="white-space: normal;"><span style="font-size: 16px;letter-spacing: 1px;"><font
              color="#C00000"><b>公众号：Auto office</b></font></span>
          </p>
          <img style="width: 180px" src="/static/image/公众号二维码.jpg">
        </div>
      </div>
    </section>
  </main>
</template>

<script>
  export default {
    name: 'about',
  }
</script>

<style scoped>
  .jumbotron {
    padding-top: 0 !important;
  }
</style>








